// extracted by mini-css-extract-plugin
export default {"my_page_menu":"my_page_menu__1fd9db1e","my_page_menu_items":"my_page_menu_items__1fd9db1e"};